module.exports = __webpack_public_path__ + "img/success.18f0ef04.svg";